import { getGameType, getVirtualKeyboard, getGameManage } from '@/api/game-manage';
import { Vue } from 'vue-property-decorator';
/* 公告查询 lyl*/
export class PublicQuery extends Vue {
  /* 游戏分类 */
  async getGameTypeList() {
    let data: any = [];
    try {
      const res = await getGameType();
      if (res.code === 0) {
        data = res.data.list;
        data.unshift({
          id: -1,
          name: '请选择游戏类别',
        });
      } else {
        console.log(res.msg);
      }
    } catch (error) {
      console.log(error);
    }
    return data;
  }
  /* 虚拟键盘列表*/
  async getVirtualKeyboard(name: string = '', page: number = 1, page_size: number = 1000) {
    let data: any = [];
    try {
      const res = await getVirtualKeyboard({ name, page, page_size });
      if (res.code === 0) {
        data = res.data.list;
        data = data.map((item: any) => {
          return { id: item.file_id, name: item.name };
        });
        data.unshift({
          id: -1,
          name: '请选择虚拟键盘',
        });
        // console.log(data);
      } else {
        console.log(res.msg);
      }
    } catch (error) {
      console.log(error);
    }
    return data;
  }
  // /* 游戏列表 */
  async getGameList(name: string = '', page: number = 1, page_size: number = 1000, source: string = 'select', act_free = -1) {
    let data: any = [];
    try {
      const res = await getGameManage({ name, page, page_size, source, act_free });
      if (res.code === 0) {
        data = res.data.list;
        data.unshift({
          id: -1,
          name: '请选择游戏类别',
        });
      } else {
        console.log(res.msg);
      }
    } catch (error) {
      console.log(error);
    }
    return data;
  }
}
